/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-enable no-console */
import anime from "animejs/lib/anime.es.js";

const buttonAnimated = document.querySelector(".sc-button-animated");

if (buttonAnimated) {
	buttonAnimated.classList.add("sc-button-animated");
}
const buttons = document.querySelectorAll(".sc-button-animated");

buttons.forEach((button) => {
	button.addEventListener("click", () => {
		const url = button.getAttribute("data-url");
		if (url) {
			window.open(url, "_blank");
		}
	});
});

buttons.forEach((button) => {
	button.addEventListener("click", () => {
		dataLayer.push({
			event: "click",
			name: button.textContent,
			page: window.location.pathname,
			id: button.textContent,
		});
	});
});
function handleIntersectButton(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			animateButtons(entry.target);
			observer.unobserve(entry.target);
		}
	});
}
let options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.0,
};
const buttonsWathcer = () => {
	let observerButtons = new IntersectionObserver(
		handleIntersectButton,
		options,
	);

	buttons.forEach((target) => {
		observerButtons.observe(target);
	});
};

buttonsWathcer();

const animateButtons = (imageLegales) => {
	anime({
		targets: imageLegales,
		translateX: [-200, 0],
		opacity: [0, 1],
		easing: "easeOutExpo",
		duration: 500,
		delay: 500,
	});
};
